module.exports = __webpack_public_path__ + "static/a18d22714c86d66c137d2203a1ea927d56e5834da724331b6be01c93925a9ff0-3b565c04afbb2dbb04d3e18c2c3e0436.jpeg";